import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
declare var $: any;

export interface ShowcaseSlide {
  title: string;
  imgUrl: string;
  category?: string;
  position?: string | number;
}

@Component({
  selector: 'app-showcase',
  templateUrl: './showcase.component.html',
  styleUrls: ['./showcase.component.scss']
})
export class ShowcaseComponent implements OnInit, OnDestroy {
  isLoading: boolean[] = [];
  sub: Subscription;

  staticFallbackSlider: ShowcaseSlide[] = [
    {
      title: 'We are ready to Build. Are you?',
      imgUrl: '/assets/img/showcase/1.jpg'
    },
    {
      title: 'A formidable career awaits you',
      imgUrl: '/assets/img/showcase/2.jpg'
    },
    {
      title: "Be a part of 150+ years’ legacy",
      imgUrl: '/assets/img/showcase/3.jpg'
    },
    {
      title: "Vision Is Everything",
      imgUrl: '/assets/img/showcase/4.jpg'
    },
    {
      title: "Be a part of 150+ years’ legacy",
      imgUrl: '/assets/img/showcase/5.jpg'
    },
    {
      title: "Be a part of 150+ years’ legacy",
      imgUrl: '/assets/img/showcase/6.jpg'
    },
    {
      title: "Be a part of 150+ years’ legacy",
      imgUrl: '/assets/img/showcase/7.jpg'
    },
    {
      title: "Be a part of 150+ years’ legacy",
      imgUrl: '/assets/img/showcase/8.jpg'
    }
  ];

  slider: ShowcaseSlide[] = [];

  constructor(
    private firebase: AngularFireDatabase,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // 1. Initial state with fallback slides
    this.slider = [...this.staticFallbackSlider];
    this.setLoader();

    // 2. Realtime listener to Firebase key 'showcase'
    this.sub = this.firebase.list('showcase').snapshotChanges().subscribe({
      next: (list) => {
        if (list && list.length > 0) {
          const raw = list.map(item => ({ key: item.key, val: item.payload.val() }));
          const parsed = this.parseRawData(raw.reduce((acc: any, cur: any) => {
            acc[cur.key] = cur.val;
            return acc;
          }, {}));

          if (parsed.length > 0) {
            this.slider = [...parsed, ...this.staticFallbackSlider];
            this.setLoader();
            this.cdr.detectChanges();
            this.restartCarousel();
          }
        } else {
          this.fetchViaRest();
        }
      },
      error: () => {
        this.fetchViaRest();
      }
    });

    // 3. Fast REST fallback
    setTimeout(() => {
      this.fetchViaRest();
    }, 400);

    setTimeout(() => {
      this.restartCarousel();
    }, 200);
  }

  private parseRawData(data: any): ShowcaseSlide[] {
    if (!data) return [];

    let rawList: any[] = [];
    if (Array.isArray(data)) {
      rawList = data.map((val, idx) => ({ key: String(idx), val }));
    } else if (typeof data === 'object') {
      rawList = Object.keys(data).map(key => ({ key, val: data[key] }));
    }

    const slides: ShowcaseSlide[] = [];

    rawList.forEach(item => {
      const obj = (typeof item.val === 'object' && item.val !== null) ? item.val : {};
      const title = obj.title || obj.caption || 'Aryakulam Showcase';
      const category = obj.category || 'Slider Background';
      const position = obj.position || '1';

      const candidateFields = [obj.imgUrl, obj.imageUrl, obj.url, obj.fileUrl, obj.image, obj.images];
      let firstUrl = '';

      for (const field of candidateFields) {
        if (Array.isArray(field) && field.length > 0 && typeof field[0] === 'string') {
          firstUrl = field[0].trim();
          break;
        } else if (typeof field === 'string' && field.trim() !== '') {
          firstUrl = field.trim();
          break;
        }
      }

      if (firstUrl) {
        slides.push({
          title: title,
          imgUrl: firstUrl,
          category: category,
          position: position
        });
      }
    });

    return slides.sort((a, b) => Number(a.position || 1) - Number(b.position || 1));
  }

  private async fetchViaRest() {
    try {
      const config = (environment as any).firebaseConfig || (environment as any).firebase;
      if (!config || !config.databaseURL) return;
      const dbUrl = config.databaseURL;
      const res = await fetch(`${dbUrl}/showcase.json`);
      if (res.ok) {
        const json = await res.json();
        if (json) {
          const parsed = this.parseRawData(json);
          if (parsed.length > 0) {
            this.slider = [...parsed, ...this.staticFallbackSlider];
            this.setLoader();
            this.cdr.detectChanges();
            this.restartCarousel();
          }
        }
      }
    } catch (e) {
      console.warn('Showcase REST fetch notice:', e);
    }
  }

  restartCarousel() {
    try {
      if (typeof $ !== 'undefined' && $('#showcaseCarousel').length) {
        $('#showcaseCarousel').carousel('dispose');
        $('#showcaseCarousel').carousel({
          interval: 4500,
          pause: false
        });
      }
    } catch (e) {}
  }

  setLoader() {
    this.isLoading = this.slider.map(() => false);
  }

  hideLoader(i: number) {
    if (this.isLoading[i] !== undefined) {
      this.isLoading[i] = false;
    }
  }

  trackByUrl(index: number, item: ShowcaseSlide): string {
    return item.imgUrl || String(index);
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
